import { viewService } from '../Services/viewService';
import { IStandardState } from '../Interfaces/IStandardState';
import { Page } from '../Enums/Page';

class StandardCommon {

    constructor() {
        const initalState: IStandardState = JSON.parse((<HTMLElement>document.getElementById('initialState')).innerHTML);
        this.setState(initalState);
    }

    public setState(state: IStandardState): void {
        viewService.setupStandardView(state.standardCode, state.standardName, Page.CommonComponent);
    }
}

export const standardCommon = new StandardCommon();